import { Component, Input, inject } from '@angular/core';
import { I18nService } from '@shared/i18n/i18n.service';

/**
 * The message theme
 */
export enum IconMessageTheme {
  Alert = 'alert',
  Error = 'error',
  Info = 'info',
}

@Component({
  selector: 'app-icon-message',
  templateUrl: './icon-message.component.html',
  styleUrls: ['./icon-message.component.scss'],
  standalone: false,
})
export class IconMessageComponent {
  private readonly i18n = inject(I18nService);

  public readonly IconMessageTheme = IconMessageTheme;

  @Input()
  public message: string = '';

  @Input()
  public messageType: IconMessageTheme | `${IconMessageTheme}` = IconMessageTheme.Error;

  @Input()
  public set transMessage(trans: string) {
    this.message = this.i18n.getPhrase(trans);
  }

  public get isError(): boolean {
    return [IconMessageTheme.Alert, IconMessageTheme.Error].map((theme) => theme.toString()).includes(this.messageType);
  }
}
